// extracted by mini-css-extract-plugin
export default {"container":"imagePlaceHolder_container__7gAQ8"};